import { EmptyResponseEntity } from "types/emptyResponseEntity";

import { APIHandler } from "utilities/apiHandler";

import {
    type AuthenticatedConnectUser,
    ParagonUserDataReponse,
    ParagonUserTokenResponse,
} from "entity/marketplace/MarketplaceDirectory/MarketplaceDirectory.api.types";

export interface IMarketplaceDirectoryHandler {
    getParagonUserToken(): Promise<ParagonUserTokenResponse>;
    storeUserData(user: AuthenticatedConnectUser): Promise<EmptyResponseEntity>;
    getUserData(): Promise<ParagonUserDataReponse>;
}

export class MarketplaceDirectoryHandler implements IMarketplaceDirectoryHandler {
    async getParagonUserToken(): Promise<ParagonUserTokenResponse> {
        return await APIHandler("/api/Marketplace/GetParagonUserToken", {
            method: "GET",
            responseType: ParagonUserTokenResponse,
        });
    }

    async storeUserData(user: AuthenticatedConnectUser): Promise<EmptyResponseEntity> {
        return await APIHandler("/api/Marketplace/StoreParagonUserData", {
            method: "POST",
            data: { paragonInformation: user },
            responseType: EmptyResponseEntity,
        });
    }

    async getUserData(): Promise<ParagonUserDataReponse> {
        return await APIHandler("/api/Marketplace/GetParagonUserData", {
            method: "GET",
            responseType: ParagonUserDataReponse,
        });
    }
}

export const defaultMarketplaceDirectoryHandler = new MarketplaceDirectoryHandler();
